import { Card } from "react-bootstrap";
import Link from "next/link";
import { BsYoutube } from "react-icons/bs";
import { useEffect, useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { renderOptions } from "../../pages/blog/[...post]";
import Image from "next/image";

export default function BetCastCard({ post, isFuture = false }) {
  const [readMore, serReadMore] = useState(false);

  return (
    <>
      <div className="row box-shadow-1 pt-3 pb-3 border-radius-10">
        <div className="col-md-4 col-12 blog-card ">
          <Link href={`${post.fields?.episodeYoutubeUrl}`}>
            <Card.Img
              className="border-radius-10"
              variant="top"
              src={`https:${post.fields?.episodeImage?.fields?.file?.url}`}
            />
          </Link>
          <h4 className="pt-3">
            <a className="is-link text-black" href="https://twitter.com/shotqualitybets" target="_blank">
              <Image
                className="d-inline"
                src={"/static/media/logos/twitterX.png"}
                height={22}
                width={22}
                style={{ width: "auto" }}
                alt="twitter"
              />
              {isFuture ? "Tune In" : "Replay"}
            </a>
            <a className="is-link text-black ml-3" href="https://www.youtube.com/@ShotQualityBets" target="_blank">
              <BsYoutube style={{ fontSize: "2rem" }} /> {isFuture ? "Tune In" : "Replay"}
            </a>
          </h4>
        </div>
        <div className="col-md-8 col-12 position-relative">
          <div className="d-flex align-items-end justify-content-between gap-1 flex-wrap-reverse">
            <Link href={`${post.fields?.episodeYoutubeUrl}`}>
              <h4 className="is-link text-black " style={{ maxWidth: "36rem" }}>
                {" "}
                <span style={{ fontSize: "1.7rem" }}>▶</span> {post.fields?.episodeTitle}
              </h4>
            </Link>
            {post.fields?.episodeSponsor.includes("Sporttrade") && (
              <Link className="is-link text-black" style={{ minWidth: "11.6rem" }} href={"https://getsporttrade.com/"}>
                <span style={{ fontSize: ".7rem" }}>PRESENTED BY</span>
                <Image
                  src={"/static/media/logos/sporttrade.png"}
                  height={32}
                  width={120}
                  style={{ width: "auto" }}
                  alt="sporttrade"
                />
              </Link>
            )}
          </div>
          <p>{post.fields?.episodeDate.split("T")[0]}</p>
          <p className="text-black pt-1" style={{ fontSize: "1.1rem" }}>
            {post.fields?.episodeMetaDescription}
          </p>
          <div className="mb-5">
            {post.fields?.episodeParticipants.map((item, index) => (
              <Link
                key={index}
                className="is-link text-black mr-4 mt-3 d-inline-block"
                href={`/author/${item.fields?.name}`}
                target="_blank"
              >
                <Image
                  className="d-inline"
                  src={`https:${item.fields?.authorImage?.fields?.file?.url}`}
                  height={40}
                  width={40}
                  style={{ width: "auto", borderRadius: "50%" }}
                  alt="twitter"
                />{" "}
                <h5 className="d-inline is-link">{item.fields?.name}</h5>
              </Link>
            ))}
          </div>
          <div className="">
            <button
              style={{ bottom: "0rem", right: "1rem" }}
              onClick={() => serReadMore(!readMore)}
              className="btn btn-orange position-absolute"
            >
              {readMore ? "Read Less" : "Read More"}
            </button>
          </div>
          {readMore && (
            <div className=" card-text mb-5 mt-5" style={{ fontSize: ".9rem" }}>
              {documentToReactComponents(post.fields?.episodeDescription || "", renderOptions)}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
